import { render, staticRenderFns } from "./index.vue?vue&type=template&id=55fc7afb&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=55fc7afb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fc7afb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55fc7afb')) {
      api.createRecord('55fc7afb', component.options)
    } else {
      api.reload('55fc7afb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=55fc7afb&scoped=true&", function () {
      api.rerender('55fc7afb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/storeInfo/category/index.vue"
export default component.exports